import React from 'react'
import { AccordionContainer } from '../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../common/components/form/input/containers/input.container';
import { selectListItems } from '../../../../../redux/library/selector';
import { useSelector } from 'react-redux';

export default function DBABasicInfoComponent ({gateways,applications,handleFormChange,selectedDba,handleInnerFormChange,domainDetails,networks}: any) {
  const libraryData = useSelector(selectListItems)
  return (
    <>
      <AccordionContainer
    child={
      <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
           <InputContainer
              label="Name"
              name="Name"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'Name',

                )
              }}
              type="text"
              value={selectedDba?.Name}
          />
         <InputContainer
                          label="DBA Type"
                          labelField="Text"
                          list={libraryData?.result?.DBAType}
                          onValueChange={( newValue: any) => {
                            const valueData: any = newValue.map((option: any) => option?.value)
                            handleInnerFormChange(
                             valueData,
                             'Types'
                           )
                          }}
                          type="multiselect"
                           valueField="Text"
                          value={selectedDba?.Types}
                          
                      />
          {/* <InputContainer
              label="Url"
              name="Url"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'Url',

                )
              }}
              type="text"
              value={selectedDba?.Url}
          /> */}
          <InputContainer
            label="Domain Name" 
                             labelField="Name"
                             list={domainDetails}
                             onValueChange={( newValue: any) => {
                               const valueData: any = newValue.map((option: any) => option?.value)
                               handleFormChange(
                                valueData,
                                'DomainMappings.Domains',
                                selectedDba?.DomainMappings
                              )
                             }}
                             type="multiselect"
                             valueField="Id"
                             value={selectedDba?.DomainMappings?.Domains}
         />
        <InputContainer
            label="Network Name" 
                             labelField="DisplayName"
                             list={networks}
                             onValueChange={( newValue: any) => {
                               const valueData: any = newValue.map((option: any) => option?.value)
                               handleFormChange(
                                valueData,
                                'NetworkMappings.Networks',
                                selectedDba?.NetworkMappings
                              )
                             }}
                             type="multiselect"
                             valueField="Id"
                             value={selectedDba?.NetworkMappings?.Networks}
         />
          <InputContainer
            label="Application Name" 
                             labelField="DisplayName"
                             list={applications}
                             onValueChange={( newValue: any) => {
                               const valueData: any = newValue.map((option: any) => option?.value)
                               handleFormChange(
                                valueData,
                                'ApplicationMappings.Applications',
                                selectedDba?.ApplicationMappings
                              )
                             }}
                             type="multiselect"
                             valueField="Id"
                             value={selectedDba?.ApplicationMappings?.Applications}
         />
         {/* <InputContainer
            label="Gateway Name" 
                             labelField="Name"
                             list={gateways}
                             onValueChange={( newValue: any) => {
                               const valueData: any = newValue.map((option: any) => option?.value)
                               handleFormChange(
                                valueData,
                                'GatewayMappings.Gateways',
                                selectedDba?.GatewayMappings
                              )
                             }}
                             type="multiselect"
                             valueField="Id"
                             value={selectedDba?.GatewayMappings?.Gateways}
         /> */}
         <div className='col-span-full'>
        <InputContainer
       
            label="Description"
            name="Description"
            onValueChange={(event: any) => {
              handleInnerFormChange(
                event,
                'Description',

              )
            }}
              type="rte"
            value={selectedDba?.Description}
        /></div>
        </div>
}
    expandedPanel="userInfo"
    headerTitle="Basic Info"
/>

        </>
  )
}